import { ElementRef } from '@angular/core';

export class DomUtils {

  static isEmptyObject(obj: any) {
		for (var name in obj) {
			return false;
		}
		return true;
  }

  static decodeText(text: string, keepLineBreaks?: boolean): string {
    var div = document.createElement('div');
    div.innerHTML = text != null ? text : '';
    if (keepLineBreaks) {
      return div.innerText.trim();
    } else {
      return div.innerText.replace(/\r?\n|\r/g, ' ').trim();
    }
  }

  static getCardHeight(el: ElementRef) {
    const uiCardQuery = el.nativeElement.getElementsByClassName('p-card');
    return uiCardQuery[0].offsetHeight;
  }

  static getCardBodyHeight(el: ElementRef, previousCardHeight?: number) {
    const uiCardQuery = el.nativeElement.getElementsByClassName('p-card');
    const uiCardHeaderQuery = el.nativeElement.getElementsByClassName('p-card-header');
    if (uiCardQuery?.length && uiCardHeaderQuery?.length) {
      const cardHeight = previousCardHeight || uiCardQuery[0].offsetHeight;
      return cardHeight - uiCardHeaderQuery[0].offsetHeight;
    } else {
      return undefined;
    }
  }

  static getParents(elem: any, selector: string) {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        (Element.prototype as any).matchesSelector ||
        (Element.prototype as any).mozMatchesSelector ||
        (Element.prototype as any).msMatchesSelector ||
        (Element.prototype as any).oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        function(s) {
          var matches = (this.document || this.ownerDocument).querySelectorAll(s),
            i = matches.length;
          while (--i >= 0 && matches.item(i) !== this) {}
          return i > -1;
        };
    }

    // Setup parents array
    var parents = [];

    // Get matching parent elements
    for ( ; elem && elem !== document; elem = elem.parentNode ) {
      // Add matching parents to array
      if ( selector ) {
        if ( elem.matches( selector ) ) {
          parents.push( elem );
        }
      } else {
        parents.push( elem );
      }
    }

    return parents;
  }

  static highlight(text: string, search: string): string {
    if (!search) return text != null ? text : '';
    if (text == null) return '';

    search = search.replace(/\*/g, ''); // remove wildcards?...
    const pattern = search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    const regex = new RegExp(pattern, 'gi');

    return text.toString().replace(regex, (match) => { return `<em>${match}</em>`; });
  }

  static maskInput(inputId: string, mask: RegExp) {
    const searchEl = document.getElementById(inputId);
    if (searchEl) {
      searchEl.onkeyup = () => {
        const value = (searchEl as HTMLInputElement).value;
        const match = value.match(mask);
        if (!match || match[0] !== value) {
          (searchEl as HTMLInputElement).value = !match ? '' : match.join('');
        }
      }
    }
  }

  // Bulk-pasted nbsp (between every word) blocks wrapping; collapse runs of 4+ nbsp-joined
  // words to regular spaces for display, leaving sparse intentional nbsp (e.g. "10 km") alone.
  // Splits on nbsp instead of matching word(nbsp word){3,} in one regex: that pattern
  // backtracks quadratically over long unbroken text, and a pasted base64 image freezes
  // the page for minutes.
  static normalizeNbspRuns(html: string): string {
    if (typeof html !== 'string') return html;

    const parts = html.replace(/&#160;|&nbsp;/gi, '\u00a0').split('\u00a0');
    const separators: string[] = new Array(parts.length - 1).fill('\u00a0');

    let start = 0;
    while (start < separators.length) {
      if (!DomUtils.joinsWords(parts[start], parts[start + 1])) {
        start++;
        continue;
      }

      // a run carries on only through parts that are a single unbroken word
      let end = start;
      while (end + 1 < separators.length && DomUtils.isWord(parts[end + 1]) && DomUtils.joinsWords(parts[end + 1], parts[end + 2])) {
        end++;
      }
      if (end - start >= 2) separators.fill(' ', start, end + 1);

      start = end + 1;
    }

    let text = parts[0];
    for (let i = 1; i < parts.length; i++) {
      text += separators[i - 1] + parts[i];
    }
    return text;
  }

  private static isWord(part: string): boolean {
    return !!part && part.search(/[\s<]/) < 0;
  }

  private static joinsWords(before: string, after: string): boolean {
    return !!before && !!after && !/[\s<]/.test(before[before.length - 1]) && !/[\s<]/.test(after[0]);
  }

  static copyTextToClipboard(text: string) {
    if (!(navigator as any).clipboard) {
      DomUtils.fallbackCopyTextToClipboard(text);
      return;
    }
    (navigator as any).clipboard.writeText(text)
    .then(() => {
      console.log('Copying to clipboard was successful!');
    }, (err) => {
      console.error('Could not copy text: ', err);
    });
  }

  private static fallbackCopyTextToClipboard(text: string) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      const msg = successful ? 'successful' : 'unsuccessful';
      console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
  }

}